<template>
    <div class="mainpage">
        <Dialog v-model:visible="dialogVisible" @update:visible="cancel()" position="center" modal header="Warning" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <p class="m-0">
                Please whitelist {{ registeredDlt }} short domain with your preferred Header to use URL Shortener.
            </p>
        </Dialog>
        <Form @submit="submitShort">
            <!-- <div class="d-flex">
                <div class="m-3 p-3">
                    <RadioButton v-model="checked" disabled :value="checked" /> <strong>Static Links</strong>
                </div>
                <div class="m-3 p-3">
                    <RadioButton v-model="dynamicChecked" disabled :value="checked" /> <strong>Dynamic Links</strong>
                </div>
            </div> -->
            <div class="input-fields">
                <label class="mb-1" for="bulk-upload">Enter Upload Name </label>
                <Field name="name" :rules="(value) => value !== ''" v-model="uploadName" v-slot="{ field, errors }">
                    <InputText type="text" v-bind="field" placeholder="Upload Name" class="set-width"/>
                    <span class="validation-error">{{ errors[0] }}</span>
                </Field>
            </div>
            <div class="input-fields">
                <!-- <label class="mb-1" for="static-url">Select File</label>
                <Dropdown v-model="fileSelected" :options="fileList" placeholder="Select file from drop down" class="set-width"/>
                     -->
                <label class="mb-1" for="static-url">Long URL</label>
                <Dropdown v-model="longurl" filter :options="getTableData" optionLabel="Cta" placeholder="Filter by CTA type" class="set-width"/>
            </div>
            <div class="options">
                <p class="fw-bold">Short Link Options</p>
                <div>

                    <div class="d-flex justify-content-start align-items-center mb-4">
                        <div class="d-flex flex-column gap">
                            <label class="mb-1" for="protocol">Protocol</label>
                            <div class="d-flex justify-content-start align-items-center">
                                <!-- <Dropdown class="domain-dropdown gap" v-model="protocol" :options="protocolOptions" placeholder="https" optionLabel="label" optionValue="value" disabled/> -->
                                <InputText id="protocol" type="text" v-model="protocol" aria-describedby="backhalf-help" disabled/>
                            </div>
                            <small class="hide-text"></small>
                        </div>
                        <div class="d-flex flex-column gap">
                            <label class="mb-1" for="static-url">Domain</label>
                            <div class="d-flex justify-content-start align-items-center">
                                <!-- <Dropdown optionLabel="Domain" optionValue="Domain" class="domain-dropdown gap" v-model="domain" :options="getActiveDomains" disabled/> -->
                                <InputText id="domain" type="text" v-model="domain" aria-describedby="backhalf-help" disabled/>
                                <p class="m-0 px-2"> / </p>
                            </div>
                            <small class="hide-text"></small>
                        </div>
                        <div class="d-flex flex-column gap">
                            <label class="mb-1" for="static-url">Header</label>
                            <div class="d-flex justify-content-start align-items-center">
                                <Dropdown optionLabel="name" optionValue="name" class="domain-dropdown gap" v-model="identifier" filter :options="getIdentifiers" placeholder="Header"/>
                                <p class="m-0"> / </p>
                            </div>
                            <small class="hide-text"></small>
                        </div>
                        <div class="d-flex flex-column">
                            <label class="mb-1" for="backhalf">Dynamic</label>
                            <InputText style="background-color: #eee" id="backhalf" type="text" v-model="backHalf" aria-describedby="backhalf-help" disabled/>
                            <small class="hide-text"></small>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-md-12 col-sm-12 mb-3">
                    <div class="d-flex align-items-center col-12 mb-3">
                        <div class="col-lg-5 col-md-5 col-sm-5">
                            <p class="mb-0">Select short link length after /</p>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-3">
                            <Dropdown class="def-dropdown" v-model="pathLength" :options="lengths" />
                        </div>
                    </div>
                </div>
                <div class="content__footer_rules mb-3">
                        <div v-for="(item, idx) in url_shorten_rules" :key="idx">
                            {{ idx + 1 }}. {{ item }}
                        </div>
                    </div>
            </div>
            <div class="white-background mb-3">
                <div class="upload-area" @click="openFileInput">
                    <img src="@/assets/images/upload_icon.svg" alt="Upload Icon" class="upload-icon" />
                    <p>Browse Files to Upload</p>
                    <p> ( Upload csv file only | Max file size is 5MB )</p>
                </div>
                <input required type="file" ref="fileInput"  accept=".csv" @change="handleFileUpload" style="display: none" />
            </div>
            <div v-show="fileSelected" class="file-upload">
                <i class="pi pi-check-circle"></i>
                <div>{{ this.fileSelected.name }}</div>
                <p v-if="uploadProgress!==100" >Uploading: {{ uploadProgress }}%</p>
                <p v-else >Completed</p>
                <ProgressBar :value="uploadProgress" :showValue="false"></ProgressBar>
            </div>
            <div class="mb-3">
                <span>Download {{ this.isDynamic === true ? 'dynamic' : 'static' }} sample file </span><i class="pi pi-download ml-1 point" style="margin-left:10px;" @click="downloadSampleFile" ></i>
            </div>
            <div class="actions-btns">
                <div class="gap">
                    <Button label="Submit" type="submit"/>
                </div>
                <div>
                    <Button label="Cancel" severity="secondary" @click="cancel"/>
                </div>
            </div>
        </Form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'
import { urlProtocols, lengths, protocolOptions } from '@/constants'
import config from '@/config/config'
import Toastr from 'toastr'

export default {
    name: 'NewLink',
    data () {
        return {
            dialogVisible: false,
            isDynamic: false,
            identifier: '',
            protocolOptions,
            linkName: '',
            longurl: '',
            domain: config.DEFAULT_DOMAIN,
            backHalf: '',
            allowShort: true,
            allowTracking: true,
            protocol: 'https://',
            urlProtocols: urlProtocols,
            pathLength: 6,
            lengths: lengths,
            checked: true,
            uploadName: '',
            fileList: [],
            fileSelected: '',
            dynamicChecked: false,
            uploading: false,
            uploadProgress: 0,
            disableSave: true,
            url_shorten_rules: [
                `For shortening static URLs, Upload Mobile numbers. A Dynamic link will be generated for each mobile number`,
                `For shortening Dynamic URLs, Upload  Mobile numbers and the full long Dynamic URLs in the File. A Dynamic link will be generated for each mobile number.`,
                `Examples: https://${config.DEFAULT_DOMAIN}/HEADER/abcdef (HEADER will be an active Header selected and 'abcdef' string will be dynamically generated).`,
                `The validity of this URL will be 1 day.`
            ],
            registeredDlt: config.REGISTERED_DLT
        }
    },
    methods: {
        cancel () {
            this.$router.push('/link/bulk')
        },
        isRequired (value) {
            if (!value) {
                return 'This is a required field'
            }
            return true
        },
        async submitShort () {
            console.log('cta', this.longurl.Cta)
            const data = {
                type: '.csv',
                isDynamic: this.longurl.HasVariable,
                uploadName: this.uploadName,
                cta: this.longurl.Cta,
                protocol: this.protocol,
                domain: this.domain,
                identifier: this.identifier,
                shortUrl: this.protocol + this.domain + '/' + this.identifier,
                pathLength: this.pathLength,
                file: this.fileSelected
            }
            if (this.longurl === '') {
                Toastr.error('Short Link', 'Long URL is required')
                return
            } else if (data.identifier === '') {
                Toastr.error('Short Link', 'Header is required')
                return
            } else if (data.file === '') {
                Toastr.error('Short Link', 'File is required')
                return
            }

            this.globalLoader = true
            await this.$store.dispatch('Links/Link/uploadFile', data)
            this.$router.push('/link/bulk')
            this.globalLoader = false
        },
        handleFileUpload (event) {
            this.fileSelected = event.target.files[0]
            this.uploading = false
            this.uploadProgress = 0
            if (this.fileSelected && this.fileSelected.name.toLowerCase().endsWith('.csv')) {
                this.uploading = true
                const interval = setInterval(() => {
                    this.uploadProgress += 10
                    if (this.uploadProgress >= 100) {
                        clearInterval(interval)
                        if (this.uploadName) {
                            this.disableSave = false
                        }
                    }
                }, 300)
            }
        },
        openFileInput () {
            this.$refs.fileInput.click()
        },
        downloadSampleFile () {
            if (this.isDynamic === true) {
                this.$store.dispatch('Cta/Whitelist/downloadSampleFile', { url: '/files/links/dynamic_sample.csv', name: `dynamic_sample.csv` })
            } else {
                this.$store.dispatch('Cta/Whitelist/downloadSampleFile', { url: '/files/links/static_sample.csv', name: `static_sample.csv` })
            }
        }
    },
    computed: {
        ...mapGetters({ currentUser: 'currentUser' }),
        ...mapModels('general', ['globalLoader']),
        ...mapGetters('Links/Link', ['getFileData', 'getbulkLinkData']),
        ...mapGetters('Domains/Domain', ['getActiveDomains']),
        ...mapGetters('Cta/Whitelist', ['getTableData', 'getIdentifiers'])
    },
    watch: {
        longurl (url) {
            if (url.HasVariable === true) {
                this.isDynamic = true
            } else {
                this.isDynamic = false
            }
        }
    },
    async beforeMount () {
        this.fileList = JSON.parse(localStorage.getItem('bulkCtaFile')) || []
        this.fileList = this.fileList.map((item) => `${item.upload_name} | ${item.file_name}`)
        await this.$store.dispatch('Cta/Whitelist/fetchIdentifiers', { shortdomain: 'https://' + config.DEFAULT_DOMAIN, from_db: true })
        if (this.getIdentifiers.length === 0) {
            this.dialogVisible = true
        } else {
            this.dialogVisible = false
        }
    },
    async mounted () {
        this.globalLoader = true
        await this.$store.dispatch('Cta/Whitelist/fetchCtas', { completeList: true, type: 'url', subtype: { value: ['sd'], operator: 'not in' }, status: 1 })
        this.globalLoader = false
    }
}
</script>

<style scoped>
.options {
    margin-bottom: 1rem;
    background-color: white;
    padding: 1rem;
}
.domain-dropdown {
    width: 200px;
}
.hide-text:empty::before {
  content:"";
  display: inline-block;
}
.shortCheck {
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
}
.p-dropdown-panel {
    max-width: 500px;
}
.set-width {
    width: 60%;
}
</style>
